import { ApiBaseData, ApiFilter, ApiNumberRangeFilter, ApiSingleSelectionFilter } from '@ibe/api';

/* eslint-disable no-prototype-builtins */
export const isApiSingleSelectionFilter = (item: ApiFilter): item is ApiSingleSelectionFilter => {
  return item.hasOwnProperty('selectedOption');
};

export const isApiBase = (option: object): option is ApiBaseData => {
  return option.hasOwnProperty('description') && option.hasOwnProperty('code');
};

const isApiNumberRangeFilter = (item: ApiFilter): item is ApiNumberRangeFilter => {
  return item.hasOwnProperty('min') && item.hasOwnProperty('max');
};
/* eslint-enable no-prototype-builtins */

export default isApiNumberRangeFilter;
